import Skeleton from '@material-ui/lab/Skeleton';
import React from 'react';

import styles from './LoadingState.scss';

const WidgetRow: React.FC = () => (
  <div className={styles.widgetRow}>
    <Skeleton variant="rect" height="21px" width="350px" animation="pulse" />
    <Skeleton variant="rect" height="40px" width="70px" animation="pulse" />
  </div>
);

const WidgetHeaderRow: React.FC = () => (
  <div className={styles.widgetHeaderRow}>
    <Skeleton variant="rect" height="21px" width="21px" animation="pulse" />
    <Skeleton variant="rect" height="21px" width="200px" animation="pulse" />
  </div>
);

export default () => (
  <div className={styles.wrapper}>
    <Skeleton variant="rect" height="48px" width="100%" animation={false} />
    <WidgetHeaderRow />
    <WidgetRow />
    <WidgetRow />
  </div>
);
